import { useI18n } from '@change-corgi/core/react/i18n';
import { useTracking } from '@change-corgi/core/react/tracking';

import { useCurrentUser } from 'src/app/shared/hooks/session';

import { useMembershipModalState } from '../../../../../modalContext';

import { useSubmit } from './hooks/useSubmit';

type Result = ModelHookResult<
	{
		localizedAmount: string;
		loading: boolean;
		headline: string;
	},
	{
		clickAccept: () => Promise<void>;
		clickDecline: () => void;
		clickAcceptDifferentAmount: () => void;
	}
>;

type Props = {
	onAccept: () => void;
	onDecline: () => void;
	onDeclineWithReason: () => void;
};

export function useSlideUpForm({ onAccept, onDecline, onDeclineWithReason }: Props): Result {
	const [{ amount, currencyCode, formState }] = useMembershipModalState();
	const { localizeCurrency } = useI18n();
	const submit = useSubmit({ onAccept, onDecline });
	const track = useTracking();
	const user = useCurrentUser();
	const firstName = user?.firstName ?? '';

	return {
		data: {
			localizedAmount: localizeCurrency(amount, currencyCode),
			loading: formState?.status === 'loading',
			headline: `Thanks, ${firstName}! Now, will you also become a member of Change.org to keep petitions free for everyone?`,
		},
		actions: {
			clickAccept: async () => {
				void track('membership_ask_slide_up_accept');
				await submit();
			},
			clickDecline: () => {
				void track('membership_ask_slide_up_decline');
				onDecline();
			},
			clickAcceptDifferentAmount: () => {
				void track('membership_ask_slide_up_accept_different_amount');
				onDeclineWithReason();
			},
		},
	};
}
